const TableBody = ({ columns, handleSelectChange, data, selectedRows, selectable, cellFormat }) => {
    if (typeof selectedRows == 'undefined') selectedRows = [];
    if (typeof data == 'undefined' || data === null) {
        return (
            <tbody>
                <tr>
                    <td colspan="6" class="text-center">
                        <div class="spinner-border text-warning" role="status">
                            <span class="visually-hidden">Loading data in table body...</span>
                        </div>
                    </td>
                </tr>
            </tbody>
        );
    } else if ( data.length < 1) {
        return (
            <tbody>
                <span class="small ms-2">Aucun résultat</span>
            </tbody >
        );
    }
    return (
        <tbody>
            {data.map((item) => {
                let valueReturn = '';
                return (
                    <tr key={item.id} className={selectedRows.includes(item.id) && selectable ? 'selected' : ''} >
                        {columns.map(({ accessor }) => {
                            let value = item[accessor] ? item[accessor] : "——";
                            valueReturn = cellFormat ? cellFormat(value, accessor, item) : value;
                            return (
                                <td key={accessor} class={"td-" + accessor.replace(' .', '-')} onClick={() => handleSelectChange(item.id, accessor)}>
                                    <div dangerouslySetInnerHTML={{ __html: valueReturn }} />
                                </td>
                            );
                        })}
                    </tr>
                );
            })}
        </tbody>
    );
};

export default TableBody;